import ChangePas from './ChangePas';
export default ChangePas;
